import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { ICardType } from '../interfaces/ICardType';
import { CardsService } from '../services/CardsService';
import { IIssuer } from '../interfaces/IIssuer';
import { IIdAndName } from '../../../../core/interfaces/IIdAndName';

export const cardsResolver: ResolveFn<ICardType[]> = () => {
  return inject(CardsService).getCardTypes()
    .pipe(map(res => res.data));
};

export const usableCardsResolver: ResolveFn<ICardType[]> = () => {
  return inject(CardsService).getUsableCardTypes()
    .pipe(map(res => res.data));
};

export const issuersResolver: ResolveFn<IIssuer[]> = () => {
  return inject(CardsService).getIssuers()
    .pipe(map(res => res.data));
};

export const productGroupsResolver: ResolveFn<IIdAndName<number>[]> = () => {
  return inject(CardsService).getProductGroups()
    .pipe(map(res => res.data));
}
